<div *ngIf="formControlInput">
    <!-- Show button when input field is not visible -->
    <button
        *ngIf="!showInputField"
        type="button"
        class="btn__add"
        (click)="handleAddButtonClick()">
        <span class="btn__base--left">
            <i class="fa-sharp fa-solid fa-circle-plus"></i>
        </span>
        <span class="btn__base--right">
            {{buttonLabel}}
        </span>
    </button>

    <!-- Show input field when button is clicked or field has value -->
    <div *ngIf="showInputField">
        <div class="border-container form-field-container mt-4">
            <span class="border-text" [class.hide-label]="!formControlInput.value" [class.show-label]="!!formControlInput.value">{{inputPlaceholder}}</span>
            <input
                type="text"
                class="form-control"
                placeholder="{{inputPlaceholder}}"
                [formControl]="formControlInput"
                [attr.id]="inputId ?? null"
                [attr.name]="inputId ?? null"
                [attr.autocomplete]="autocomplete"
                [attr.maxlength]="maxLength ?? null"
                autofocus />
        </div>
        <span class="text-danger" *ngIf="shouldShowError && firstErrorMessage">
            {{ firstErrorMessage }}
        </span>
    </div>
</div>
